module.exports = __webpack_public_path__ + "static/img/show-title.e181df59.png";